import React, { useState, useEffect } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PasswordResetPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const nav = useNavigate();

  useEffect(() => { document.title = "Recuperar contraseña · Mimes Gourmet"; }, []);

  const request = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/customer/password/request-reset`, { email });
      setSent(true);
    } catch { toast.error("Error, inténtalo de nuevo"); }
    setBusy(false);
  };

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/customer/password/confirm-reset`, { token, new_password: password });
      toast.success("Contraseña actualizada. Ya puedes entrar.");
      nav("/cuenta/entrar");
    } catch (err) { toast.error(err.response?.data?.detail || "Enlace inválido o expirado"); }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <p className="eyebrow mb-3">Recuperar contraseña</p>
      <h1 className="font-serif text-4xl text-[color:var(--brand-primary)] font-light">
        {token ? "Nueva contraseña" : "¿Contraseña olvidada?"}
      </h1>

      {!token && !sent && (
        <form onSubmit={request} className="mt-8 space-y-3">
          <p className="text-sm text-[color:var(--brand-neutral)]">Te enviaremos un enlace para restablecerla.</p>
          <Input data-testid="reset-email" type="email" required placeholder="tu@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button data-testid="reset-request-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] hover:bg-black text-white rounded-md py-5">
            {busy ? "…" : "Enviar enlace"}
          </Button>
        </form>
      )}

      {!token && sent && (
        <div data-testid="reset-sent" className="mt-8 text-sm text-[color:var(--brand-neutral)]">
          Si el email existe en nuestra base, recibirás un enlace en unos segundos. Revisa también tu carpeta de spam.
        </div>
      )}

      {token && (
        <form onSubmit={confirm} className="mt-8 space-y-3">
          <Input data-testid="reset-new-password" type="password" required minLength={8} placeholder="Nueva contraseña (mín. 8)" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button data-testid="reset-confirm-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] hover:bg-black text-white rounded-md py-5">
            {busy ? "…" : "Guardar contraseña"}
          </Button>
        </form>
      )}

      <p className="text-xs mt-8 text-center">
        <Link to="/cuenta/entrar" className="underline text-[color:var(--brand-neutral)]">Volver a entrar</Link>
      </p>
    </div>
  );
}
